import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/models/responses/api-response.model';
import { Station } from 'src/app/models/responses/station-response.model';
import { EnvironmentService } from '../environment-service/environment.service';

@Injectable({
  providedIn: 'root',
})
export class StationService {
  private static readonly CONTROLLER_ROOT = 'v1/stations';

  constructor(private httpClient: HttpClient) {}

  getActiveStations(): Observable<ApiResponse<Station[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${StationService.CONTROLLER_ROOT}/active`;
    return this.httpClient.get<ApiResponse<Station[]>>(endpoint);
  }

  getActiveStationsWithMarkets(): Observable<ApiResponse<Station[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${StationService.CONTROLLER_ROOT}/active/withmarkets`;
    return this.httpClient.get<ApiResponse<Station[]>>(endpoint);
  }

  getActiveStationsWithConnectionMarkets(): Observable<ApiResponse<Station[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${StationService.CONTROLLER_ROOT}/active/withconnectionmarkets`;
    return this.httpClient.get<ApiResponse<Station[]>>(endpoint);
  }
}
